import React from 'react';
import i18next from 'i18next';
import styled from 'styled-components';
import { colors } from '../../../styles/colors';
import { NavLink } from 'react-router-dom';

type Props = {
  options: MenuOption[];
};

type MenuOption = {
  url: string;
  title: string;
};

export class MenuGroup extends React.PureComponent<Props> {

  render() {
    const { options } = this.props;

    if (options.length === 1) {
      const item = options[0];
      return <NavLinkItem to={item.url} activeClassName="is-active" >{i18next.t(item.title)}</NavLinkItem>;
    }
  }

}

const NavLinkItem = styled(NavLink)`
  display: block;
  color: white !important;
  padding: 0.5em 0.5em 0.5em 1em;
  font-size: 1em !important;

  &:hover {
    background-color: ${colors.darkPurple} !important;
  }
  &.is-active {
    background-color: ${colors.darkPurple} !important;
    font-weight: bold;
  }
`;